import { es as es$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var es = {
  language: 'es',
  country: 'es',
  name: 'Español',
  embeddedLocale: merge(error, login),
  flags: ['ES'],
  dateFns: es$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { es as default };
